/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getSurveyUsers,
} from '../actions/api';
import { UserMin } from '@g17eco/types/user';

type Data = { users: UserMin[] };

interface InitialState {
  loaded: boolean;
  errored: boolean;
  errorMessage: string;
  surveyId: undefined;
  data: Data;
}

const initialState: InitialState = {
  loaded: false,
  errored: false,
  errorMessage: '',
  surveyId: undefined,
  data: { users: [] }
};

const surveyDelegationUsers = createSlice({
  name: 'surveyDelegationUsers',
  initialState: initialState,
  reducers: {
    load: (state, action) => {
      return { ...initialState, surveyId: action.payload };
    },
    loaded: (state, action: PayloadAction<Data>) => {
      return { ...state, loaded: true, errored: false, errorMessage: '', data: action.payload, }
    },
    error: (state, action) => {
      return { ...state, errored: true, errorMessage: action.payload };
    }
  }
})

export const { load, loaded, error } = surveyDelegationUsers.actions

export default surveyDelegationUsers.reducer

export const loadDelegationUsers = (id: string, forceReload = false, blockingLoad = true): any => {

  return async (dispatch: any, getState: () => any) => {

    const state: InitialState = getState().surveyDelegationUsers;
    if (id === state.surveyId && state.loaded && !forceReload) {
      return;
    }

    if (blockingLoad) {
      dispatch(load(id));
    }

    getSurveyUsers(id).then(
      (users: Data) => {
        dispatch(loaded(users))
      },
      (err: Error) => {
        dispatch(error(err.message));
      }
    )
  };
}

export const reloadDelegationUsers = (id: string): any => loadDelegationUsers(id, true, false);
